import { container } from "assets/jss/material-kit-react.jsx";

const signupPageStyle = {
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    paddingTop: "20vh",
    color: "#FFFFFF",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  pageHeader: {
    minHeight: "100vh",
    maxHeight: "1200px",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""'
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    }
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "75px",
    marginRight: "75px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  searchInput: {
    fontSize: "18px",
    width: 250, //max size for xs, could adjust later for other screens...
    '&::placeholder': {
      fontSize: "22px",
    }
  },
  divider: {
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    "& a": {
      color: "#0000ee",
    }
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  site: {
  	display: "flex",
    alignItems: "center",
  	flexDirection: "column",
  	margin: "0 auto",
  	justifyContent: "center",
  },
  sketch: {
  	position: "relative",
  	height: 400,
  	minWidth: 400,
  	margin: 0,
  	overflow: "visible",
  	order: 2,
  },
};

export default signupPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/404Page.jsx